import React, { useState, Fragment } from "react";
import { allUsers } from "../../../data/mockData";
import AdminDataTable from "../components/AdminDataTable";
import Button from "../../../components/ui/Button";
import FanDetailModal from "../components/FanDetailModal";
import { MoreVertical, Trash2, Eye } from "lucide-react";
import { Menu, Transition } from "@headlessui/react";

const UserManagementPage = () => {
  const [fans, setFans] = useState(allUsers.filter(u => u.role === "Fan"));
  const [selectedFan, setSelectedFan] = useState(null);

  const fanColumns = [
    {
      header: "Fan",
      key: "name",
      width: "220px",
      render: (row) => (
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center text-slate-500 font-bold border border-slate-200">
            {row.name.charAt(0)}
          </div>
          <div>
            <p className="font-medium text-slate-800">{row.name}</p>
            <p className="text-xs text-slate-500">{row.email}</p>
          </div>
        </div>
      ),
      sortable: true
    },
    {
      header: "Join Date",
      key: "joinDate",
      width: "120px",
      render: (row) => <span className="text-sm text-slate-600">{row.joinDate}</span>,
      sortable: true
    },
    {
      header: "Activity",
      key: "activity",
      width: "140px",
      render: (row) => (
        <div className="space-y-1">
          <div className="flex justify-between items-center text-xs">
            <span className="text-slate-500">Subs:</span>
            <span className="font-semibold text-purple-600">{Math.floor(Math.random() * 5) + 1}</span>
          </div>
          <div className="flex justify-between items-center text-xs">
            <span className="text-slate-500">Items:</span>
            <span className="font-semibold text-blue-600">{Math.floor(Math.random() * 15) + 3}</span>
          </div>
        </div>
      ),
    },
    {
      header: "Support",
      key: "support",
      width: "160px",
      render: (row) => (
        <div className="space-y-1">
          <div className="flex justify-between items-center text-xs">
            <span className="text-slate-500">Tips:</span>
            <span className="font-semibold text-green-600">ETB {(Math.random() * 5000 + 500).toFixed(0)}</span>
          </div>
          <div className="flex justify-between items-center text-xs">
            <span className="text-slate-500">Donations:</span>
            <span className="font-semibold text-pink-600">{Math.floor(Math.random() * 10)} Causes</span>
          </div>
        </div>
      ),
    },
    {
      header: "Experience",
      key: "experience",
      width: "120px",
      render: (row) => (
        <div className="text-center">
          <p className="font-bold text-orange-600">{Math.floor(Math.random() * 8)}</p>
          <p className="text-xs text-slate-500">Booked</p>
        </div>
      ),
      sortable: true
    },
    {
      header: "Value (Lifetime)",
      key: "totalSpent",
      width: "140px",
      render: (row) => (
        <div>
          <p className="font-bold text-slate-800">{(Math.random() * 20000 + 2000).toLocaleString()} ETB</p>
          <p className="text-xs text-green-600 font-medium">High Value</p>
        </div>
      ),
      sortable: true
    },
    {
      header: "Status",
      key: "status",
      width: "100px",
      render: (row) => (
        <span
          className={`px-2 py-1 rounded-full text-xs font-semibold ${
            row.status === "Active" 
              ? "bg-green-100 text-green-700" 
              : "bg-red-100 text-red-700"
          }`}
        >
          {row.status}
        </span>
      ),
      sortable: true
    },
    {
      header: "Actions",
      key: "actions",
      width: "100px",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Button
            variant="ghost"
            size="sm"
            className="w-8 h-8 p-0 text-slate-400 hover:text-blue-600 hover:bg-blue-50"
            onClick={() => setSelectedFan(row)}
            title="View Details"
          >
            <Eye size={16} />
          </Button>
          <Button
            variant="ghost"
            size="sm"
            className="w-8 h-8 p-0 text-slate-400 hover:text-red-600 hover:bg-red-50"
            onClick={() => {/* Suspend logic */}}
            title="Suspend Fan"
          >
            <Trash2 size={16} />
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-slate-800">
            Fan Management
          </h1>
          <p className="text-slate-500 mt-1">
            Comprehensive view of all fan activity and interactions across the platform.
          </p>
        </div>
      </div>

      <AdminDataTable 
        title="All Fans" 
        columns={fanColumns} 
        data={fans} 
        searchableFields={["name", "email"]}
        filterableFields={[
          { key: "status", label: "Status", options: ["Active", "Suspended"] }
        ]}
      />
      
      {selectedFan && (
        <FanDetailModal 
          fan={selectedFan} 
          onClose={() => setSelectedFan(null)} 
        />
      )}
    </div>
  );
};

export default UserManagementPage;
